import { Typography } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import "moment-timezone";
import React, { useEffect, useState } from "react";
import { useAppDispatch } from "src/app-redux/hooks";
import { assignRolesModulesAction } from "src/app-redux/management/actions/managementActions";
import UseWindowDimensions from "src/common/utils/getWindowDimensions";
import { useStyles } from "./style";

interface Props {
  isShow: boolean;
  childModuleId: any;
  roleId: string;
  terminalId: string;
  submitCounter: number;
  roleSelectedActions: any;
}

export function ActionsComponent({
  isShow,
  childModuleId,
  roleId,
  terminalId,
  submitCounter,
  roleSelectedActions,
}: Props): React.ReactElement {
  const classes = useStyles();
  const dispatch = useAppDispatch();

  const { height } = UseWindowDimensions();
  let wHeight = 0;
  let gridMaxHeight = 0;
  let dppr = 10;
  wHeight = height - 132;
  gridMaxHeight = height - 200;
  if (height > 700 && height < 900) {
    dppr = 15;
  } else if (height > 900) {
    dppr = 25;
  } else {
    dppr = 10;
  }
  useEffect(() => {
    if (submitCounter) {
      const res: any = dispatch(assignRolesModulesAction(JSON.stringify(stateFinalSubmitArr)));
    }
  }, [submitCounter]);

  const [checked, setChecked] = React.useState<any>([]);
  const [stateMyMapping, setStateMyMapping] = useState<any>([]);
  const [stateFinalSubmitArr, setstateFinalSubmitArr] = useState<any>([]);
  useEffect(() => {
    if (roleSelectedActions.length !== 0) {
      const newData = roleSelectedActions?.mappings.map((item: any) =>
        Object.assign({}, item, { selected: false })
      );
      setStateMyMapping(newData);
      const finalSubmitArr = {
        roleId: roleId,
        mappings: newData,
        terminalId: terminalId,
      };
      setstateFinalSubmitArr(finalSubmitArr);
    }
  }, [roleSelectedActions]);

  const handleCheckBoxSelection = (value: any) => () => {
    const newData = JSON.parse(JSON.stringify(stateMyMapping)); // from DB
    let newChecked: any = [];
    newData.map((item: any) => {
      if (item.moduleId === childModuleId) {
        if (item.actionIds) newChecked = item?.actionIds;
      }
    });
    const currentIndex = newChecked.indexOf(value);
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    const newArr: any = { moduleId: childModuleId, actionIds: newChecked };
    if (stateMyMapping.length === 0) {
      //Record all Empty
      stateMyMapping.push(newArr);
    } else if (stateMyMapping.findIndex((i: any) => i.moduleId === childModuleId) !== -1) {
      // Record Found
      stateMyMapping.map((item: any) => {
        item.moduleId === childModuleId ? (item.actionIds = newChecked) : item;
      });
    } else if (stateMyMapping.findIndex((i: any) => i.moduleId === childModuleId) === -1) {
      // Record Not Found
      stateMyMapping.push(newArr);
    }

    const newMyMapping = stateMyMapping;
    setStateMyMapping(newMyMapping);
    const finalSubmitArr = {
      roleId: roleId,
      terminalId: terminalId,
      mappings: stateMyMapping,
    };
    setstateFinalSubmitArr(finalSubmitArr);
  };
  const getCheckedValofModule = (index: any) => {
    let checkedValuesofSubMod: any = [];
    let outPut = false;
    stateMyMapping.map((item: any) => {
      if (item.moduleId === childModuleId) {
        checkedValuesofSubMod = item.actionIds;
      }
    });
    if (checkedValuesofSubMod && checkedValuesofSubMod.length !== 0)
      outPut = checkedValuesofSubMod.indexOf(index) !== -1;
    else outPut = false;
    return outPut;
  };

  const actionsArr = ["Create", "Update", "Delete", "Read"];
  return (
    <div className={classes.rolesRightSection}>
      <Typography className="subHeading">{"Actions"}</Typography>
      {isShow == true && (
        <List className={classes.list}>
          {actionsArr.map((value: any, index1: number) => {
            const index = index1 + 1;
            const labelId = `checkbox-list-label-${value}`;
            return (
              <ListItem
                key={value}
                role={undefined}
                dense
                button
                onClick={handleCheckBoxSelection(index)}
                className={classes.listItem}
              >
                <ListItemIcon>
                  <Checkbox
                    edge="start"
                    checked={getCheckedValofModule(index)}
                    tabIndex={-1}
                    disableRipple
                    inputProps={{ "aria-labelledby": labelId }}
                  />
                </ListItemIcon>
                <ListItemText id={labelId} primary={`${value}`} />
              </ListItem>
            );
          })}
        </List>
      )}
    </div>
  );
}
